<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      My Device
    </div>
    <div class="content">
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          pulling-text="Pull down to refresh"
          loading-text="Loading..."
          success-text="Refresh success"
          loosing-text="Release to refresh"
      >
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="No more data"
            loading-text="Loading more..."
            :error.sync="error"
            error-text="Load fail! Click reload"
            @load="onLoad"
        >

          <div
              ref="nofiticationWrap"
              class="notification-item grid grid-cols-2 gap-3"
          >
            <FavoriteDeviceItem
                @click="click(item)"
                @onFavoriteClick="onFavoriteClick(item,index)"
                v-for="(item, index) in historyList"
                :device="item"
                :key="index"/>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import log from "@/util/log";
import { WriterSetting } from "@/bluetooth/BluetoothData";
import { calcPower } from "../util/utils";
import HistoryCurve from "@/views/HistoryCurve.vue";
import { mapState } from "vuex";
import CurveItem from "@/components/history/CurveItem.vue";
import user from "@/api/user";
import userMixin from "@/mixins/userMixin";
import SystemCurve from "@/components/home/SystemCurve.vue";
import SystemCurveItem from "@/components/home/SystemCurveItem.vue";
import ConsumerCurveItem from "@/components/history/ConsumerCurveItem.vue";
import FavoriteDeviceItem from "@/components/mydevice/FavoriteDevicetem.vue";

export default {
  name: "MyFavoriteDevice",
  mixins: [userMixin],
  components: { FavoriteDeviceItem, ConsumerCurveItem, SystemCurveItem, SystemCurve, CurveItem, HistoryCurve },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      historyList: [],
      pageNum: 1,
      pageSize: 10,
      itemWidth: 0
    };
  },
  created() {
  },
  async mounted() {
  },
  computed: {
    ...mapState("theme", ["curveColor", "curveLineColor", "syncButtonColor"])
  },
  methods: {
    click(item) {
      this.$router.push({
        name: "MyFavoriteDevice",
        query: {
          newsId: item.id,
          title: item.eventName
        }
      });
    },
    async onFavoriteClick(item,index) {
      try {
        const isFavorite = item.isFavorite === 1;
        const resp = await user.favoriteDevice({
          isFavorite: isFavorite ? 0 : 1,
          tag: item.tag
        });
        if (resp.code !== 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }
        item.isFavorite = isFavorite ? 0 : 1;
        this.$toast({
          type: "success",
          message: resp.message
        });
      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }
    },
    onClickHeaderReturn() {
      this.$router.go(-1);
    },
    onApply(index, item) {
      const writerSetting = new WriterSetting();
      Object.assign(writerSetting, item);
      const name = this.$route.query.modelType == 1 ? "Enterprise" : "BtHome";
      this.$router.replace({
        name,
        params: {
          writerSetting
        }
      });
    },
    async onFavorite(index, item) {
      try {
        const isFavorite = item.isFavorite ? 0 : 1;
        const resp = await user.myFavoriteDevice({
          id: item.id,
          brandId: this.$route.query.brandId
        }, true);
        this.$set(this.historyList, index, { ...this.historyList[index], isFavorite });
        this.historyList[index].isFavorite = isFavorite;
        this.$toast({
          type: "success",
          message: resp.message
        });
      } catch (e) {
        this.$toast({
          type: "fail",
          message: e
        });
      }

    },
    async onRefresh() {
      this.refreshing = true;
      this.onLoad();
    },
    async onLoad() {
      //如果是刷新
      if (this.refreshing) {
        this.pageNum = 1;
        this.historyList = [];
      }
      try {
        let response = await this.$api.User.myFavoriteDevice({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          brandId: this.$route.query.brandId
        });
        const history = response.data;
        const total = response.total;
        // log(history);
        this.historyList = this.historyList.concat(history);

        this.finished = true
        // //刷新结束
        // if (this.refreshing) {
        //   this.refreshing = false;
        // } else {
        //   this.loading = false;
        // }
        // if (this.historyList.length >= total) {
        //   this.finished = true;
        // }
        // this.pageNum += 1;
      } catch (e) {
        log(e);
        this.loading = false;
        this.error = true;
      }
    },
    calcHistoryPower(voltage, r, maxPower) {
      return calcPower(voltage, r, maxPower);
    }
  }
};
//圆点
</script>
<style lang="less" scoped>
.container {
  height: 100%;
  background: #FFFFFF;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333333;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }

  .content {
    height: 100%;
    overflow-y: auto;
    background: #EEF0F2;

    .notification-item {
      margin-left: 16px;
      margin-right: 16px;
      border-radius: 12px;
    }
  }
}

.van-list {
  text-align: center;

  & > * {
    margin-top: 12px;
  }

}
</style>
